import { Component, OnInit } from '@angular/core';
import { DoctorsService } from '../../shared/doctor-service/doctors.service';
import { Router, NavigationExtras,ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
@Component({
  selector: 'app-view-doctor',
  templateUrl: './view-doctor.component.html',
  styleUrls: ['./view-doctor.component.css']
})
export class ViewDoctorComponent implements OnInit {
city: any;
count = 16;
CityDoctor:any;
clinicArray:any;
imgindex:any;
curindex:number= 0 ;
recieveData:any;
istrue = false;
isactive :Boolean= false;
moment:any = moment;
path = 'https://dev.api.doqmatokens.com/';
  constructor(private doctorService: DoctorsService ,private router:Router,private route:ActivatedRoute) { 
    const navigation = this.router.getCurrentNavigation();
  this.recieveData = this.route.snapshot.paramMap.get('id');
  // navigation.extras.state as {
  //   transId: string,
  // };
  console.log(this.recieveData ,"this is recieve data");
  
  }

  ngOnInit(){
    this.city = "najibabad";
    window.scrollTo(0,0)
  //  0 < this.index > this.CityDoctor?.data.clinicId.length; 
    // this.getAlldoctors();
if(this.recieveData){
  this.getSingleDoctor();

}
// if(this.index == null){
//   this.index = 0;
//   this.istrue = true;
//   this.changeclinic(this.index);
// }
    
  }
  // getAlldoctors(){
  
  //   this.doctorService.getCityDoctor(this.city,this.count).subscribe((data:any)=>{
  //     this.CityDoctor = data.data;
      
      // console.log("this is city doctor data",this.path);
      // console.log("this is doctor",data);
      
  // });
// }
getSingleDoctor(){
  this.doctorService.viewDoctor(this.recieveData).subscribe((res)=>{
    console.log(res,"this is doctor");
    this.CityDoctor = res;
    this.istrue = true;
    // this.clinicArray = this.CityDoctor?.data?.clinicId[0];
    // console.log("this is clinic array",this.clinicArray);
    // this.clinicArray = res;
    this.changeclinic(this.curindex);
    this.CityDoctor?.data?.clinicId?.forEach(element => {
      if(element.clinicStatus=='ONLINE'){
        this.isactive = true;
      }
    });
    // if(this.CityDoctor?.data?.clinicId.forec)
  })
}
changeclinic(index:number){
  this.clinicArray = this.CityDoctor?.data?.clinicId[index];
  this.istrue = true;
  this.curindex = index;
  console.log("this is clinic array",this.clinicArray);
  
}
veiwimg(index){
  // console.log(index,"this is index of cliic image");
  this.imgindex = index;
}
dcCounter(){
  this.imgindex = this.imgindex - 1 ;
  if(this.imgindex < 0){
    let i=this.clinicArray?.clinicImages.length;
    this.imgindex = i - 1;
  }
}
incCounter() {
  this.imgindex = this.imgindex +1;
   if(this.imgindex >= this.clinicArray?.clinicImages.length){
     
     this.imgindex = 0;
   // console.log("low value",this.viewclinic);
   
   }
 }
}
